import type * as React from 'react';
import type { User } from '../../../MedicareProAPI/Entities/User/User';

export interface UserAvatarProps {
  user: User;
  className?: string;
  style?: React.CSSProperties;
  onClick?: (user: User) => void;
}

export const UserAvatar = (props: UserAvatarProps): React.JSX.Element => {
  const style = props.style || {};
  const profileImageValid =
    props.user.getProfilePic() && props.user.getProfilePic().getProfilePicUrl();

  if (profileImageValid) {
    style.backgroundImage = 'url(' + props.user.getProfilePic().getProfilePicUrl() + ')';
    style.backgroundSize = 'contain';
    style.backgroundPosition = 'center top';
  }

  const containerProps: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > = {
    className: 'cp avatar-circle-center' + (props.className ? ' ' + props.className : ''),
    style: style,
  };

  return (
    <div {...containerProps}>
      {!profileImageValid && (
        <span className="">
          {props.user.getUserFirstname()[0]} {props.user.getUserLastname()[0]}
        </span>
      )}
    </div>
  );
};
